import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { api } from "@/lib/api";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials")
      .then((r) => setItems(r.data))
      .catch((err) => console.warn("Testimonials load failed:", err?.message || err));
  }, []);
  if (!items || items.length === 0) return null;
  return (
    <section data-testid="testimonials-section" className="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--clinic-muted))]">Pacientes</div>
        <h2 className="mt-2 font-display text-3xl sm:text-4xl">Lo que dicen quienes ya nos visitaron.</h2>
        <p className="mt-2 text-xs italic text-[hsl(var(--clinic-muted))]">Publicamos únicamente testimonios con consentimiento escrito del paciente.</p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((t) => (
          <figure key={t.id} data-testid={`testimonial-${t.id}`} className="flex flex-col rounded-2xl border border-[hsl(var(--clinic-border))] bg-white p-6">
            <Quote size={28} className="text-[hsl(var(--clinic-primary))]" />
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed">"{t.quote}"</blockquote>
            <div className="mt-4 flex items-center justify-between">
              <figcaption className="text-sm font-semibold">— {t.patient_name}</figcaption>
              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={`star-${t.id}-${i}`} size={12} className={i < (t.rating || 5) ? "fill-[hsl(var(--clinic-secondary))] text-[hsl(var(--clinic-secondary))]" : "text-[hsl(var(--clinic-border))]"} />
                ))}
              </div>
            </div>
          </figure>
        ))}
      </div>
    </section>
  );
}
